import { BehaviorSubject } from "rxjs";
import { IDateFormControlOptions } from "../date-form-control";
import { _SSControlOptionsBase } from "./types/_ss-control-options-base";
import { FormControlOptionsUtils } from "./utils/form-control-options-utils";


export class SSDateOptions implements _SSControlOptionsBase<'date'> {

  formatSubject = new BehaviorSubject<IDateFormControlOptions['format']>('dd/MM/yyyy');

  minSubject = new BehaviorSubject<Date>(null);

  constructor(
    private _initialOptions?: IDateFormControlOptions
  ) {

    this._initOptions();
  }

  private _initOptions() {

    FormControlOptionsUtils.initMappedObject<'date'>(this, this._initialOptions);

  }

  dispose() {

  }
}
